module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suchen…","spots":"Spots"},"en":{"search":"Search…","spots":"Spots"}}')
  delete Component.options._Ctor
}
